import React from "react";

const Breadcrumb = ({ activeSection, subSection = null, onNavigate }) => {
  // Sidebar menu structure (same as AdminSidebar)
  const menuItems = {
    dashboard: "Dashboard",
    userManagement: "Recruiter Management",
    entities: "Entities Management",
    compliance: "Compliance & Governance",
    settings: "System Configuration",
  };

  // Build breadcrumb path dynamically
  let path = [];

  if (activeSection === "dashboard") {
    path = [{ id: "dashboard", label: "Dashboard" }];
  } else {
    path = [
      { id: "dashboard", label: "Dashboard" },
      { id: activeSection, label: menuItems[activeSection] || activeSection },
    ];

    // ✅ Add a third level (for example: Create User)
    if (subSection) {
      path.push({
        id: subSection.toLowerCase().replace(/\s+/g, "-"),
        label: subSection,
      });
    }
  }

  return (
    <div className="text-gray-500 text-xs pt-5 px-4 flex items-center flex-wrap">
      {path.map((item, index) => {
        const isLast = index === path.length - 1;
        return (
          <div key={item.id} className="flex items-center">
            <span
              onClick={() => !isLast && onNavigate(item.id)}
              className={`cursor-pointer transition-colors duration-150 ${
                isLast
                  ? "text-[#14532d] font-semibold"
                  : "hover:text-[#166534]"
              }`}
            >
              {item.label}
            </span>
            {!isLast && <span className="mx-1 text-gray-400">{">"}</span>}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumb;